export default {
    props: {
        fileBrowserFileTypes: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.fileTypes'
        }, 
        fileBrowserPath: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.path'
        }, 
        fileBrowserTransportRead: {
            type: [String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.read'
        }, 
        fileBrowserTransportReadContentType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.read.contentType'
        }, 
        fileBrowserTransportReadData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.read.data'
        }, 
        fileBrowserTransportReadDataType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.read.dataType'
        }, 
        fileBrowserTransportReadType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.read.type'
        }, 
        fileBrowserTransportReadUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.read.url'
        }, 
        fileBrowserTransportUploadUrl: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.uploadUrl'
        }, 
        fileBrowserTransportFileUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.fileUrl'
        }, 
        fileBrowserTransportDestroy: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy'
        }, 
        fileBrowserTransportDestroyContentType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy.contentType'
        }, 
        fileBrowserTransportDestroyData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy.data'
        }, 
        fileBrowserTransportDestroyDataType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy.dataType'
        }, 
        fileBrowserTransportDestroyType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy.type'
        }, 
        fileBrowserTransportDestroyUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.destroy.url'
        }, 
        fileBrowserTransportCreate: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.create'
        }, 
        fileBrowserTransportCreateContentType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.create.contentType'
        }, 
        fileBrowserTransportCreateData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.create.data'
        }, 
        fileBrowserTransportCreateDataType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.create.dataType'
        }, 
        fileBrowserTransportCreateType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.transport.create.type'
        }, 
        fileBrowserTransportCreateUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'fileBrowser.transport.create.url'
        }, 
        fileBrowserSchemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.id'
        }, 
        fileBrowserSchemaModelFieldsName: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.name'
        }, 
        fileBrowserSchemaModelFieldsNameField: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.name.field'
        }, 
        fileBrowserSchemaModelFieldsNameParse: {
            type: Function,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.name.parse'
        }, 
        fileBrowserSchemaModelFieldsType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.type'
        }, 
        fileBrowserSchemaModelFieldsTypeParse: {
            type: Function,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.type.parse'
        }, 
        fileBrowserSchemaModelFieldsTypeField: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.type.field'
        }, 
        fileBrowserSchemaModelFieldsSize: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.size'
        }, 
        fileBrowserSchemaModelFieldsSizeField: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.size.field'
        }, 
        fileBrowserSchemaModelFieldsSizeParse: {
            type: Function,
            default: undefined,
            kComposite: 'fileBrowser.schema.model.fields.size.parse'
        }, 
        fileBrowserMessagesUploadFile: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.uploadFile'
        }, 
        fileBrowserMessagesOrderBy: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.orderBy'
        }, 
        fileBrowserMessagesOrderByName: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.orderByName'
        }, 
        fileBrowserMessagesOrderBySize: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.orderBySize'
        }, 
        fileBrowserMessagesDirectoryNotFound: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.directoryNotFound'
        }, 
        fileBrowserMessagesEmptyFolder: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.emptyFolder'
        }, 
        fileBrowserMessagesDeleteFile: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.deleteFile'
        }, 
        fileBrowserMessagesInvalidFileType: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.invalidFileType'
        }, 
        fileBrowserMessagesOverwriteFile: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.overwriteFile'
        }, 
        fileBrowserMessagesSearch: {
            type: String,
            default: undefined,
            kComposite: 'fileBrowser.messages.search'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/KendoEditor/FileBrowser.js